import { Entitlement, LIST_TIERS_QUERY, Tier } from '@graphql';
import { graphqlApi } from '@utils';
import { flow, makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';

export class TiersStore {
  private tiersData: Tier[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  getTiers = flow(function* getTiers(this: TiersStore): any {
    try {
      const tierResponse = yield graphqlApi(LIST_TIERS_QUERY);
      this.tiersData = tierResponse?.data?.data?.listTiers;
    } catch (err) {
      toast('Something went wrong!', { type: 'error' });
    }
  }).bind(this);

  getTierNameById = (tierId: string): string =>
    this.tiersData.find((tier) => tier.id === tierId)?.name || '';

  getTierAddons = (tierId: string): Entitlement[] => {
    try {
      return (
        this.tiersData
          .find((tier) => tier.id === tierId)
          ?.entitlements.filter((entitlement) => entitlement.type === 'add-on') || []
      );
    } catch (err) {
      toast('Something went wrong!', { type: 'error' });
      return [];
    }
  };

  get tiers(): Tier[] {
    return this.tiersData || [];
  }
}
